export enum PlayerTimeFormat {
  Standard = 'standard',
  Frames = 'frames',
  Timecode = 'timecode',
}

export const PLAYER_TIME_FORMAT_LABEL_MAP = {
  [PlayerTimeFormat.Standard]: 'Standard',
  [PlayerTimeFormat.Frames]: 'Frames',
  [PlayerTimeFormat.Timecode]: 'Timecode',
};
